import {
  ChangeJobRequest,
  CorretJobRequest,
  EStoreExecutorTable,
  ID,
  JOB_STATUS_CLIENT_NAMES,
  JOB_STATUS_COLORS,
  JobBase,
  JobReview,
  JobStatus,
  WORK_CORRECT_CAUSE_NAMES,
  WorkView
} from "@project/shared-types";
import { useEffect, useMemo, useState } from "react";
import { JobChangeAPI, JobChangeCorrectAPI } from "../../../api/JobsAPI";
import CloseSvg from "../../../assets/taiga-uikit/icons/close.svg?react";
import { Button } from "../../../components/button/button";
import { Divider } from "../../../components/Divider/Divider";
import { FeedBack } from "../../../components/FeedBack/FeedBack";
import { FixedPage } from "../../../components/FixedPage/FixedPage";
import { InfoCardJob } from "../../../components/InfoCardJob/InfoCardJob";
import { InputAI } from "../../../components/InputAI/InputAI";
import { InputDatePicker } from "../../../components/InputDatePicker/InputDatePicker";
import { Input } from "../../../components/inputs/Input";
import { InputImageLoader } from "../../../components/inputs/InputImageLoader";
import { KeyWordBlock } from "../../../components/KeyWordBlock/KeyWordBlock";
import { Loader } from "../../../components/Loader/Loader";
import { Push } from "../../../components/Push/Push";
import { RadioButton } from "../../../components/RadioButton/RadioButton";
import { Copy } from "../../../components/texts/Copy/Copy";
import { Label } from "../../../components/texts/label";
import { Text } from "../../../components/texts/text";
import { _colorText, _size, _sizeText, _style } from "../../../core/core";
import { get_date_from_string } from "../../../hooks/date_tool";
import { TimeStampToStringDate } from "../../../hooks/timestamp_to_string_date";
import "./FixedCardJob.css";

export interface EditorJobFixedProps<T extends JobBase> {
  order_id: ID;
  job_data: T;
  work?: WorkView;
  set_is_active: React.Dispatch<React.SetStateAction<boolean>>;
  is_forge_correct?: boolean;
  is_active?: boolean;
  [key: string]: any;
}

export const EditorJobFixed: React.FC<EditorJobFixedProps<JobReview>> = ({
  order_id,
  job_data,
  work,
  set_is_active,
  is_forge_correct = false,
  is_active = false,
  ...props
}) => {
  const [isEdit, setIsEdit] = useState(false);
  const [job, setJob] = useState<JobReview>(job_data);
  const [isCorrectActive, setIsCorrectActive] = useState(is_forge_correct);
  const [currentCause, setCurrentCause] = useState("edit_text");
  const [CorrectComment, setCorrectComment] = useState("");
  const [text, setText] = useState(job.properties.text || "");
  const [keywords, setKeywords] = useState(job.properties.keywords || []);
  const [file, setFile] = useState<ID>();
  const [filepath, setFilePath] = useState<string | undefined>();
  const [isImageEdit, setIsImageEdit] = useState(false);
  const [date, setDate] = useState<number>(job_data.date_public);
  const [isLoading, setIsLoading] = useState(false);

  const isEditPermission = useMemo(() => {
    return [JobStatus.DO, JobStatus.NO_WORK].includes(job.status) || isCorrectActive;
  }, [job.status, isCorrectActive]);
  const isFeedBack = useMemo(() => {
    return [JobStatus.CLOSE, JobStatus.WAIT_PAY].includes(job.status);
  }, [job.status]);

  const featchCorrect = async () => {
    try {
      const requestData = {
        order_id: order_id,
        job_id: job.id,
        correct: currentCause,
        comment: CorrectComment,
      } as CorretJobRequest;
      const response = await JobChangeCorrectAPI(requestData);
      if (!response) return;
      setJob(response.job as JobReview);
      setIsCorrectActive(false);
    } catch (error) {
      console.error("Ошибка при получении карточек услуг:", error);
    }
  };

  const fetchChangeJob = async () => {
    try {
      setIsLoading(true);
      const requestData = {
        order_id: order_id,
        job_id: job.id,
        text: text,
        keywords: keywords,
        file_ids: [filepath],
        date_public: date,
      } as ChangeJobRequest;
      const response = await JobChangeAPI(requestData);
      if (!response) return;
      const newJob = response.job as JobReview;
      setIsLoading(false);
      setJob(newJob);
      if (newJob.type === "review") {
        setText(newJob.properties.text || "");
        setKeywords(newJob.properties.keywords || []);
      }
      setIsEdit(false);
    } catch (error) {
      console.error("Ошибка при получении карточек услуг:", error);
    }
  };
  const handleBeforeUnload = (event: PopStateEvent) => {
    console.log("handleBeforeUnload");
    setIsEdit(false);
    setIsCorrectActive(false);
    set_is_active(false);

    event.preventDefault(); // Предотвращаем переход на другую страницу
  };
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Enter") {
        if (isEdit) fetchChangeJob();
        else setIsEdit(true);
      } else if (event.key === "Escape") {
        setIsEdit(false);
        setIsCorrectActive(false);
      }
    };
    console.log("is_active", is_active);
    if (is_active) {
      window.addEventListener("keydown", handleKeyDown);
    }

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      if (!is_active) setIsEdit(false);
    };
  }, [is_active, isEdit]);
  const handleClickCorrect = () => {
    if (isCorrectActive) featchCorrect();
    else setIsCorrectActive(true);
  };
  const handleClick = () => {
    if (isEdit) fetchChangeJob();
    else setIsEdit(true);
  };
  const handleLoadImage = (file_id: ID) => {
    setFile(file_id);
    setFilePath(`${file_id}`);
  };
  return (
    <FixedPage
      id={job.id}
      width="750px"
      is_active={is_active}
      set_is_active={set_is_active}
      handleBeforeUnload={handleBeforeUnload}
      className="fixed-card"
    >
      {is_active && (
        <div className="j-fixed ">
          <div className="j-fixed-h">
            <div className="j-fixed-h-l">
              <div className="j-fixed-h-lg">
                <Text size={_sizeText.l} color={_colorText.black}>
                  Задание
                </Text>
                <Copy value={job.id.toString()}>
                  <Text size={_sizeText.l} color={_colorText.neutral}>
                    №{job.view_id}
                  </Text>
                </Copy>
              </div>
              <div className="j-fixed-h-rg">
                <Label size={_size.XS} status={JOB_STATUS_COLORS[job.status]}>
                  {JOB_STATUS_CLIENT_NAMES[job.status]}
                </Label>
                <Button
                  onClick={() => {
                    set_is_active(false);
                  }}
                  size={_size.XS}
                  style={_style.outline}
                  icon_left={<CloseSvg />}
                ></Button>
              </div>
            </div>
          </div>
          <Divider></Divider>
          {isEdit ? (
            <div className="j-fixed-body">
              <InputAI
                value={text}
                setValue={setText}
                job_id={job.id}
                labelOutside="Текст отзыва"
                placeholder={"Напишите свой или оставьте пустым"}
              ></InputAI>
              <KeyWordBlock
                text={text}
                keywords={keywords}
                setKeywords={setKeywords}
                job_id={job.id}
                is_edit
              ></KeyWordBlock>
              <InputDatePicker
                value={date}
                setValue={setDate}
                labelOutside="Запланировать"
              ></InputDatePicker>

              {job.file_ids && job.file_ids.length > 0 && !isImageEdit ? (
                <div className="card-job-b-column j-fixed-body-img">
                  <img
                    src={`https://viw.im${job.file_ids[0]}`}
                    height="128px"
                    width="128px"
                  ></img>
                  <Button
                    onClick={() => {
                      setIsImageEdit(true);
                    }}
                    style={_style.link}
                  >
                    Удалить
                  </Button>
                </div>
              ) : (
                <InputImageLoader
                  label={`Фото к отзыву`}
                  placeholder={`Фото к отзыву`}
                  onLoad={handleLoadImage}
                  table_id={job.id}
                  table_type={EStoreExecutorTable.JOBS}
                />
              )}
              <Push
                id={"10"}
                shadow={false}
                text={
                  "Дата планирования задания - это день, когда мы начнём искать исполнителя. Сложность и время публикации отзыва зависят от разных платформ."
                }
              ></Push>
            </div>
          ) : (
            <div className="j-fixed-body">
              {work && (
                <>
                  <InfoCardJob title="Исполнитель:" text={work.nickname} />
                  <InfoCardJob
                    title="Дата выполнения:"
                    text={get_date_from_string(
                      work.time.date_complite || work.date_modified
                    )}
                  />
                </>
              )}
              {isCorrectActive ? (
                <div className="j-cause-editor">
                  <InfoCardJob title="Что нужно исправить?" column>
                    <RadioButton
                      isActive={currentCause === "edit_text"}
                      onClick={() => {
                        setCurrentCause("edit_text");
                      }}
                    >
                      <Text size={_sizeText.hmp2} color={_colorText.black}>
                        Исправить текст
                      </Text>
                    </RadioButton>
                    <RadioButton
                      isActive={currentCause === "no_foto"}
                      onClick={() => {
                        setCurrentCause("no_foto");
                      }}
                    >
                      <Text size={_sizeText.hmp2} color={_colorText.black}>
                        Добавить фото
                      </Text>
                    </RadioButton>
                    <RadioButton
                      isActive={currentCause === "bad_name"}
                      onClick={() => {
                        setCurrentCause("bad_name");
                      }}
                    >
                      <Text size={_sizeText.hmp2} color={_colorText.black}>
                        Исправить имя
                      </Text>
                    </RadioButton>
                  </InfoCardJob>
                  <Input
                    placeholder="Комментарий*"
                    value={CorrectComment}
                    setValue={setCorrectComment}
                  ></Input>
                </div>
              ) : (
                <>
                  {job.date_public && (
                    <InfoCardJob
                      title="Запланировано:"
                      text={TimeStampToStringDate(job.date_public, "в")}
                    />
                  )}
                  {work && work.correct && (
                    <>
                      <InfoCardJob
                        title="Исправление:"
                        text={WORK_CORRECT_CAUSE_NAMES[work.correct.cause]}
                      />
                      <InfoCardJob
                        title="Ваш комментарий:"
                        text={work.correct.client_comment}
                        column
                      />
                      {work.correct.executor_comment && (
                        <InfoCardJob
                          title="Исправление:"
                          text={work.correct.executor_comment}
                        />
                      )}
                    </>
                  )}
                  {work?.text ? (
                    <InfoCardJob
                      title="Текст исполнителя"
                      text={work.text}
                      column
                    />
                  ) : (
                    <>
                      {job.properties.text && (
                        <InfoCardJob
                          title="Ваш текст"
                          text={job.properties.text}
                          column
                        />
                      )}
                    </>
                  )}
                  <KeyWordBlock
                    job_id={job.id}
                    text={job.properties.text || ""}
                    keywords={keywords}
                    setKeywords={setKeywords}
                    is_edit={false}
                  ></KeyWordBlock>
                  {job.file_ids && job.file_ids.length > 0 && !isImageEdit && (
                    <div className="card-job-b-column j-fixed-body-img">
                      <Text size={_sizeText.hmp2} color={_colorText.neutral}>
                        Фото к заданию
                      </Text>
                      <img
                        src={`https:/viw.im/${job.file_ids[0]}`}
                        height="128px"
                        width="128px"
                      ></img>
                    </div>
                  )}
                  {job.date_public && (
                    <InfoCardJob
                      title="Запланировано:"
                      text={TimeStampToStringDate(job.date_public, "на")}
                    />
                  )}
                  {job.description && (
                    <InfoCardJob
                      title="Описание:"
                      text={job.description}
                      column
                    />
                  )}
                </>
              )}
            </div>
          )}
          {work && !work.correct && (
            <Button
              width={"100%"}
              style={_style.outline}
              onClick={handleClickCorrect}
              size={_size.M}
            >
              {isCorrectActive ? "Сохранить" : "На доработку"}
            </Button>
          )}
          {isEditPermission && (
            <Button width={"100%"} onClick={handleClick} size={_size.M}>
              {isEdit ? (
                isLoading ? (
                  <Loader isLoading={isLoading} />
                ) : (
                  "Сохранить"
                )
              ) : (
                "Редактировать"
              )}
            </Button>
          )}
          {isFeedBack && (
            <FeedBack
              id={job.id}
              title="Оцените работу исполнителя"
              is_order={false}
            />
          )}
        </div>
      )}
    </FixedPage>
  );
};
